import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import FreeSolo from './searchSymptom';




const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    background: 'transparent',
    padding: theme.spacing(6, 0, 2),
    marginBottom: 8,
  },
  heroButtons: {
    marginTop: theme.spacing(3),
  },
  cardGrid: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(8),
    background: 'transparent',
    marginBottom: 16,
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: '#fff',
    borderRadius: 18,
    border: '1px solid #dce8f7',
    boxShadow: '0 4px 20px rgba(0,40,90,0.06)',
    overflow: 'hidden',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: '0 10px 28px rgba(0,40,90,0.1)',
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
    background: 'linear-gradient(135deg, #f0f5fc 0%, #e8eef7 100%)',
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(3, 3, 1.5),
  },
  cardActions: {
    padding: theme.spacing(0, 3, 3),
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  headline: {
    color: '#001e3c',
    fontWeight: 700,
    textAlign: "center",
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.7rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.8rem',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '2rem',
    },
  },
  subheadline: {
    color: '#3d5a80',
    textAlign: "center",
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.3rem',
    },
  },
  cardTitle: {
    color: '#001e3c',
    fontWeight: 700,
    textAlign: "left",
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.4rem',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.8rem',
    },
  },
  cardText: {
    color: '#3d5a80',
    lineHeight: 1.65,
    textAlign: "left",
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.0rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.0rem',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.1rem',
    },
  },
}));

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function Album() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      {/*...existing code...*/}
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Container maxWidth="sm">
            <Typography component="h1" variant="h2" align="center" gutterBottom className={classes.headline}>
              Search symptom — and see if we can help!
            </Typography>
            {/*<Typography variant="h5" align="center" color="textSecondary" paragraph className={classes.subheadline}>
              Type in something in the the searchbar below and read more about your symptom(s) and if 
            </Typography>*/}
            <div className={classes.heroButtons}>
              <Grid container direction="row" spacing={0} justify="center">
                  <Button variant="contained" style={{ background: '#fff', border: '1px solid #dce8f7', borderRadius: 14, boxShadow: '0 4px 20px rgba(0,40,90,0.06)' }}>
                    <FreeSolo />
                  </Button>
              </Grid>
            </div>
          </Container>
        </div>
        <Container className={classes.cardGrid} maxWidth="lg">
          {/* End hero unit */}
          <Grid container spacing={4}>
            {cards.map((card) => (
              <Grid item key={card} xs={6} sm={6} md={4}>
                <Card className={classes.card}>
                  <CardMedia
                    className={classes.cardMedia}
                    image=""
                    title="Image title"
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" component="h2" className={classes.cardTitle}>
                      Heading
                    </Typography>
                    <Typography className={classes.cardText}>
                      This is a media card. You can use this section to describe the content.
                    </Typography>
                  </CardContent>
                  <CardActions className={classes.cardActions}>
                    <Button size="small" color="primary">
                      View
                    </Button>
                    <Button size="small" color="primary">
                      Edit
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </main>
    </React.Fragment>
  );
}